import { notNullOrUndefined } from "../functions/notNullOrUndefined";
import { BrowserDetector } from "../browser/BrowserDetector";

export class OutOfMemoryError extends Error {
	public static readonly errorName = "OutOfMemoryError";

	constructor(message?: string) {
		super(message);

		try {
			// @ts-ignore
			this.name = OutOfMemoryError.errorName;
		} catch {
			// ignore
		}
	}

	get name(): string {
		//Not working anymore since the '"useDefineForClassFields": true' in tsconfig
		return OutOfMemoryError.errorName;
	}
}

export function isOutOfMemoryError(error: Error | null | undefined): boolean {
	return notNullOrUndefined(error) && error.name === OutOfMemoryError.errorName;
}

export const throwHasRanOutOfMemory = (inner?: Error) => {
	if (BrowserDetector.isThisALegacyBrowser()) return; //Ignore out of memory issues in legacy browsers as these just crash (IE)

	try {
		// Try to allocate a 10 MB buffer. If it fails, we assume OOM occurred
		let x: null | ArrayBuffer = new ArrayBuffer(10 * 1024 * 1024);
		x = null; // be sure this is GC-ed asap
	} catch (e) {
		throw new OutOfMemoryError(inner?.message);
	}
};

export const hasRanOutOfMemory = (inner?: Error) => {
	try {
		throwHasRanOutOfMemory(inner);
	} catch (e) {
		return true;
	}

	return false;
};
